import React from 'react';
import { Link } from 'react-router-dom';
import './Page.css';
import usePageTitle from '../hooks/usePageTitle';

function NotFound() {
  usePageTitle('Page Not Found');
  return (
    <div className="page-container">
      <div className="page-content not-found" style={{ textAlign: 'center', paddingTop: '4rem', paddingBottom: '4rem' }}>
        <h1 style={{ fontFamily: "'Lora', Georgia, serif", fontSize: '4rem', marginBottom: '0.5rem' }}>404</h1>
        <h2 style={{ marginBottom: '1.5rem' }}>Page Not Found</h2>
        <p style={{ fontFamily: "'Proxima Nova', 'Montserrat', Arial, sans-serif", maxWidth: '500px', margin: '0 auto 2rem' }}>
          The page you're looking for doesn't exist or has been moved. 
          Use the links below to find what you need.
        </p>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/" className="cta-button primary">Go Home</Link>
          <Link to="/contact" className="cta-button secondary">Contact Us</Link>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
